import { SvgIcon } from "@material-ui/core";
export const roofIcon = (
  <SvgIcon>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 122.88 61.86"
    >
      <g>
        <path d="M11.51,61.86v-2.95c-2.34,0.9-4.53,0.92-6.35,0.3c-1.42-0.48-2.62-1.34-3.5-2.45 c-0.88-1.11-1.44-2.46-1.61-3.95c-0.26-2.31,0.43-4.92,2.4-7.37l0,0c0.1-0.12,0.21-0.24,0.34-0.34L59.85,0.55 c0.74-0.68,1.88-0.75,2.7-0.11l57.19,44.46l0,0c0.09,0.07,0.17,0.14,0.25,0.23c2.65,2.85,3.31,6.01,2.67,8.68 c-0.32,1.32-0.95,2.5-1.82,3.48c-0.87,0.98-1.98,1.74-3.24,2.19c-2,0.72-4.38,0.7-6.79-0.44v2.82h-5.6v-5.28 c0-1.01-39.23-32.02-43.56-35.39c-4.59,3.49-44.54,34.25-44.54,35.55v5.13H11.51L11.51,61.86z M93.77,3.55l17.17,0.7v23.19 L93.77,16.11V3.55L93.77,3.55z" />
      </g>
    </svg>
  </SvgIcon>
);
